const GameMap = require('../views/map.js');
const Interface = require('../views/interface.js');
const Country = require('../views/country.js');
const Wave = require('../views/wave.js');
const Util = require('../views/utils.js');
const Boat = require('../views/boat.js');
const InfoScreen = require('../views/information_screen.js');
const LogicBridge = require('./logic_bridge.js');
const Player = require('./player.js');
const GameAudio = require('./audio.js');

const DIM_X = window.innerWidth - 50;
const DIM_Y = window.innerHeight - 50;

Number.prototype.between = function(a, b) {
  let min = Math.min(a, b),
    max = Math.max(a, b);
  return this > min && this < max;
};

class Game {
  constructor(restart) {
    this.humanPlayer = new Player("human","humanPlayer");
    this.countries = {
      "top-left": {
        view: "",
        object: "",
        player: null,
        options: {
          workerPercentage: 30,
          militaryPercentage: 30,
          educatorPercentage: 30
        }
      },
      "bottom-left": {
        view: "",
        object: "",
        player: null,
        options: {
          workerPercentage: 30,
          militaryPercentage: 30,
          educatorPercentage: 30
        }
      },
      "top-right": {
        view: "",
        object: "",
        player: null,
        options: {
          workerPercentage: 30,
          militaryPercentage: 30,
          educatorPercentage: 30
        }
      },
      "bottom-right": {
        view: "",
        object: "",
        player: null,
        options: {
          workerPercentage: 30,
          militaryPercentage: 30,
          educatorPercentage: 30
        }
      }
    };
    this.allMoveableObjects = [];
    this.currentAge = 0;
    this.restart = restart;
    this.notOver = true;
    this.activeGame = false;
    this.established = false;
    this.unlockPerks = false;
    this.logicBridge = new LogicBridge(this);
    this.modIsReady = false;
    this.gameAudio = new GameAudio();
    this.gameAudio.init();
    this.sound = true;
  }

  setUpGame (countries) {
    let game = this;
    Object.keys(countries).forEach((country,i) => {
      this.countries[country].object = countries[country].country;
      this.countries[country].view = new Country({ climate: countries[country].country.climate, countryNo: i, width: DIM_X, height: DIM_Y, game: game, size: countries[country].country.size });
    });
    this.interface = new Interface({ width: DIM_X, height: DIM_Y, game: game });
    this.interface.setMessage("Shapes of War");
    this.map = new GameMap({ width: DIM_X, height: DIM_Y, game: game });

    for (let i = 0; i < 20; i++) {
      this.allMoveableObjects.push(new Wave({position: i, width: DIM_X, height: DIM_Y, game: game}));
    }
    this.infoScreen = new InfoScreen({ width: DIM_X, height: DIM_Y, game: game });
  }

  draw (ctx) {
    ctx.clearRect(0,0, DIM_X, DIM_Y);
    this.map.draw(ctx);
    this.allMoveableObjects.forEach(object => object.draw(ctx));
    Object.keys(this.countries).forEach(countryName => this.countries[countryName].view.draw(ctx));
    this.infoScreen.draw(ctx);
    this.interface.draw(ctx);
  }

  isOutOfBounds (pos) {
    return (pos[0] < 0) || (pos[1] < 0) || (pos[0] > (Game.DIM_X * 0.7)) || (pos[1] > (Game.DIM_Y - 50));
  }

  removeCountry(country) {
    let newCountries = {};
    if (this.countries[country.name].player.computer) {
      for (let newCountry in this.countries) {
        if (country.name !== newCountry) {
          newCountries[newCountry] = this.countries[newCountry];
        }
      }
      this.countries = newCountries;
    } else {
      this.loseGame();
    }
  }

  handleClick (ctx, event) {
    let ratioX = event.offsetX/DIM_X;
    let ratioY = event.offsetY/DIM_Y;
    let msg;
    if (ratioY.between(0.347,0.39) &&
    ratioX.between(0.345,0.444) &&
    !this.notOver) {
      this.replayGame();
    } else {
      switch (true) {
        case ratioY < 0.1:
          if (ratioX.between(0.02,0.08) && ratioY.between(0.03,0.07)) {
            this.toggleSound();
            msg = "ignore";
          } else if (ratioX.between(0.2,0.3) && ratioY.between(0.03,0.07)){
            msg = "ignore";
          } else {
            msg = "ignore";
          }
          break;
        case this.interface.selected !== "" && ratioY.between(0.891,0.991) && ratioX.between(0.810,0.891):
          this.applyModifier(event);
          break;
        case ratioX <0.7 && ratioY > 0.1:
          msg = "mainScreenInteraction";
          break;
        case ratioX > 0.95 && ratioY > 0.95:
          this.endGame();
          break;
        case ratioY > 0.88:
          msg =  "";
          break;
        case ratioY > 0.82:
          msg = ratioX > 0.85 ? 'shady-4' : (ratioX > 0.7 ? 'technology-4' : "");
          break;
        case ratioY > 0.75:
          msg = ratioX > 0.85 ? 'shady-3' : (ratioX > 0.7 ? 'technology-3' : "");
          break;
        case ratioY > 0.68:
          msg = ratioX > 0.85 ? 'shady-2' : (ratioX > 0.7 ? 'technology-2' : "");
          break;
        case ratioY > 0.60:
          msg = ratioX > 0.85 ? 'shady-1' : (ratioX > 0.7 ? 'technology-1' : "");
          break;
        case ratioY > 0.57:
          msg = "";
          break;
        case ratioY > 0.48:
          msg = "council";
          break;
        case ratioY > 0.44:
          msg = "";
          break;
        case ratioY > 0.36:
          msg = ratioX > 0.85 ? 'military-4' : (ratioX > 0.7 ? 'domestic-4' : "");
          break;
        case ratioY > 0.29:
          msg = ratioX > 0.85 ? 'military-3' : (ratioX > 0.7 ? 'domestic-3' : "");
          break;
        case ratioY > 0.22:
          msg = ratioX > 0.85 ? 'military-2' : (ratioX > 0.7 ? 'domestic-2' : "");
          break;
        case ratioY > 0.15:
          msg = ratioX > 0.85 ? 'military-1' : (ratioX > 0.7 ? 'domestic-1' : "");
          break;
        default:
          msg = "ignore";
      }
      ctx.logicSwitch(msg,event);
    }
  }

  toggleSound () {
    if (this.sound) {
      this.gameAudio.mute();
      this.sound = false;
    } else {
      this.gameAudio.unmute();
      this.gameAudio.click.get();
      this.sound = true;
    }
  }

  logicSwitch (command,event) {
    if (typeof command === 'string') {
      this.handleInterface(command, event);
    }
  }

  handleInterface(command, event) {
    let ratioX = event.offsetX/DIM_X;
    let ratioY = event.offsetY/DIM_Y;
    if (this.interface.instructions && command !== "ignore") {
      switch (true) {
        case ratioX.between(0.8,0.901) && ratioY.between(0.3,0.4):
          this.setStage("fullInstructions");
          // this.gameAudio.click.get();
          break;
        case ratioX.between(0.8,0.901) && ratioY.between(0.8,0.902):
          this.setStage("startGame");
          // this.gameAudio.click.get();
          break;
        default:

      }
    } else if (command === "mainScreenInteraction") {
      this.handleInfoScreenInteraction(command,event);
    } else {
      switch (command) {
        case "council":
          if (this.activeGame) {
            this.setStage("bringUpCouncil");
          }
          break;
        default:
          this.setSelectedInterface(command);
      }
    }
  }

  handleInfoScreenInteraction (command, event) {
    let ratioX = event.offsetX/DIM_X;
    let ratioY = event.offsetY/DIM_Y;
    if (command === "hideInfoScreen") {
      this.interface.hideIfAllowed();
    } else if (this.interface.stage === "pickCountry") {
      this.handleCountryPicking(event);
    } else if (this.infoScreen.text.beginning){
        if (this.infoScreen.text.colors) {
          this.handleColorPicking(event);
        } else if (this.infoScreen.text.showAges) {
          this.handleAgePicking(event);
        } else if (this.infoScreen.text.decision) {
          this.handleDecision(event);
        }
    } else if (this.infoScreen.text.decision) {
        this.handleDecision(event);
    } else if (this.infoScreen.text.betweenAges ||
        this.infoScreen.text.managingPop) {
      this.handleBetweenAgesDecision(event);
    } else if (this.infoScreen.text.council) {
      switch (true) {
        case ratioY.between(0.39,0.61) && ratioX.between(0.29,0.4):
          this.selectMilitaryTarget(this.humanPlayer, 0);
          break;
        case ratioY.between(0.7,0.9) && ratioX.between(0.29,0.4):
          this.selectMilitaryTarget(this.humanPlayer, 1);
          break;
        case ratioY.between(0.39,0.61) && ratioX.between(0.49,0.6):
          this.selectMilitaryTarget(this.humanPlayer, 2);
          break;
        case ratioY.between(0.7,0.9) && ratioX.between(0.49,0.6):
          this.selectMilitaryTarget(this.humanPlayer, 3);
          break;
      }
    }
  }

  handleDecision(event) {
    let ratioX = event.offsetX/DIM_X;
    let ratioY = event.offsetY/DIM_Y;
    switch (true) {
      case ratioY.between(0.301,0.519) && ratioX.between(0.58,0.68):
        if (ratioY.between(0.301,0.364)) {
          this.gameAudio.click.get();
          this.infoScreen.selectChoice("positive-beginning");
        } else if (ratioY.between(0.454,0.519)) {
          this.gameAudio.click.get();
          this.infoScreen.selectChoice("negative-beginning");
        }
        break;
      default:
    }
  }

  updateUnallocatedPercentage () {
    this.totalUnallocatedPoints = 100 - (
      this.humanPlayer.country.options.workerPercentage +
      this.humanPlayer.country.options.militaryPercentage +
      this.humanPlayer.country.options.educatorPercentage);

    if (this.totalUnallocatedPoints === 0) {
      this.unlockPerks = true;
    } else {
      this.gameAudio.click.get();
      this.unlockPerks = false;
    }
  }

  setPlayerPriorities (player) {
    if (!player.computer) this.modIsReady = true;
    player.country.object.allocateBeings(player.country.options);
  }

  handleBetweenAgesDecision (event) {
    let ratioX = event.offsetX/DIM_X;
    let ratioY = event.offsetY/DIM_Y;
    if (this.currentAge === 0) {
      switch (true) {
        case ratioY.between(0.297,0.388) && ratioX.between(0.26,0.345):
          this.gameAudio.click.get();
          this.infoScreen.setSelectedTextDescription('selectPerk',0);
          break;
        case ratioY.between(0.297,0.388) && ratioX.between(0.46,0.537):
          this.gameAudio.click.get();
          this.infoScreen.setSelectedTextDescription('selectPerk',1);
          break;
        case ratioY.between(0.45,0.53) && ratioX.between(0.26,0.345):
          this.gameAudio.click.get();
          this.infoScreen.setSelectedTextDescription('selectPerk',2);
          break;
        case ratioY.between(0.45,0.53) && ratioX.between(0.462,0.545):
          this.gameAudio.click.get();
          this.infoScreen.setSelectedTextDescription('selectPerk',3);
          break;
        case ratioY.between(0.788,0.851) && ratioX.between(0.313,0.516):
          this.gameAudio.click.get();
          this.selectPerk(this.infoScreen.text.currentBetweenAgeMessageSelected);
          break;
        default:
      }
    } else {
      if (this.infoScreen.text.managingPop) {
        this.updateUnallocatedPercentage();
        switch (true) {
          case ratioY.between(0.347,0.39) && ratioX.between(0.345,0.444):
            if (this.unlockPerks) {
              this.gameAudio.click.get();
              this.setPlayerPriorities(this.humanPlayer);
              this.setStage('betweenAges');
            }
            break;
          case ratioY.between(0.404,0.444) && ratioX.between(0.35,0.39):
            if (this.humanPlayer.country.options.workerPercentage > 0 &&
            this.totalUnallocatedPoints < 100) {
              this.humanPlayer.country.options.workerPercentage -= 10;
              this.updateUnallocatedPercentage();
            }
            break;
          case ratioY.between(0.404,0.444) && ratioX.between(0.40,0.45):
            if (this.humanPlayer.country.options.workerPercentage < 100 &&
            this.totalUnallocatedPoints > 0) {
              this.humanPlayer.country.options.workerPercentage += 10;
              this.updateUnallocatedPercentage();
            }
            break;
          case ratioY.between(0.48,0.52) && ratioX.between(0.35,0.39):
            if (this.humanPlayer.country.options.militaryPercentage > 0 &&
            this.totalUnallocatedPoints < 100) {
              this.humanPlayer.country.options.militaryPercentage -= 10;
              this.updateUnallocatedPercentage();
            }
            break;
          case ratioY.between(0.48,0.52) && ratioX.between(0.40,0.45):
            if (this.humanPlayer.country.options.militaryPercentage < 100 &&
            this.totalUnallocatedPoints > 0) {
              this.humanPlayer.country.options.militaryPercentage += 10;
              this.updateUnallocatedPercentage();
            }
            break;
          case ratioY.between(0.56,0.60) && ratioX.between(0.35,0.39):
            if (this.humanPlayer.country.options.educatorPercentage > 0 &&
            this.totalUnallocatedPoints < 100) {
              this.humanPlayer.country.options.educatorPercentage -= 10;
              this.updateUnallocatedPercentage();
            }
            break;
          case ratioY.between(0.56,0.60) && ratioX.between(0.40,0.45):
            if (this.humanPlayer.country.options.educatorPercentage < 100 &&
            this.totalUnallocatedPoints > 0) {
              this.humanPlayer.country.options.educatorPercentage += 10;
              this.updateUnallocatedPercentage();
            }
            break;

        }
      } else {
        switch (true) {
          case ratioY.between(0.347,0.39) && ratioX.between(0.345,0.444):
            this.gameAudio.click.get();
            this.infoScreen.managePop();
            break;
        }
      }
    }
  }

  handleCountryPicking (event) {
    let ratioX = event.offsetX/DIM_X;
    let ratioY = event.offsetY/DIM_Y;
    switch (true) {
      case ratioY.between(0.128,0.5) && ratioX.between(0,0.32):
        this.selectCountry("top-left");
        break;
      case ratioY.between(1,0.5) && ratioX.between(0,0.32):
        this.selectCountry("bottom-left");
        break;
      case ratioY.between(0.128,0.5) && ratioX.between(0.7,0.32):
        this.selectCountry("top-right");
        break;
      case ratioY.between(1,0.5) && ratioX.between(0.7,0.32):
        this.selectCountry("bottom-right");
        break;
      default:
    }
  }

  handleColorPicking (event) {
    let ratioX = event.offsetX/DIM_X;
    let ratioY = event.offsetY/DIM_Y;
    switch (true) {
      case ratioY.between(0.271,0.397) && ratioX.between(0.267,0.572):
        if (ratioX.between(0.267,0.332)) {
          this.infoScreen.selectKingColor("red");
        } else if (ratioX.between(0.347,0.412)) {
          this.infoScreen.selectKingColor("lightblue");
        } else if (ratioX.between(0.427,0.492)) {
          this.infoScreen.selectKingColor("green");
        } else if (ratioX.between(0.508,0.572)) {
          this.infoScreen.selectKingColor("purple");
        }
        break;
      case ratioY.between(0.454,0.516) && ratioX.between(0.370,0.472):
        this.gameAudio.click.get();
        this.pickColor(this.infoScreen.kingColor);
        break;
      default:
    }
  }

  // For testing purposes only
  handleHeaderInteraction (event) {
    // let ratioX = event.offsetX/DIM_X;
    // let ratioY = event.offsetY/DIM_Y;
    // switch (true) {
    //   case ratioX.between(0.08, 0.118):
    //     //start game
    //     this.setStage("startGame");
    //     break;
    //   case ratioX.between(0.137, 0.164):
    //     //pick game
    //     this.setStage("instructions");
    //     break;
    //   case ratioX.between(0.18, 0.222):
    //     //make decision
    //     this.setStage("testWorker");
    //     break;
    //   case ratioX.between(0.24, 0.282):
    //     //between ages
    //     this.setStage("betweenAges");
    //     break;
    //   case ratioX.between(0.31, 0.351):
    //     //resume game
    //     this.setStage("resumeGame");
    //     break;
    //   default:
    //
    // }
  }

  handleAgePicking (event) {
    let ratioX = event.offsetX/DIM_X;
    let ratioY = event.offsetY/DIM_Y;
    switch (true) {
      case ratioY.between(0.271,0.397) && ratioX.between(0.267,0.572):
        if (ratioX.between(0.267,0.332)) {
          this.infoScreen.selectAge("10");
        } else if (ratioX.between(0.347,0.412)) {
          this.infoScreen.selectAge("20");
        } else if (ratioX.between(0.427,0.492)) {
          this.infoScreen.selectAge("30");
        } else if (ratioX.between(0.508,0.572)) {
          this.infoScreen.selectAge("50");
        }
        break;
      case ratioY.between(0.454,0.516) && ratioX.between(0.370,0.472):
        this.gameAudio.click.get();
        this.pickAge();
        break;
      default:
    }
  }

  pickAge (age) {
    this.targetAge = parseInt(this.infoScreen.text.ageSelect);
    this.infoScreen.setAge();
  }

  pickColor (color) {
    this.humanPlayer.setColor(color);
    this.infoScreen.setColor();
  }

  hideInfoScreen () {
    this.infoScreen.hide();
  }

  selectMilitaryTarget (player, target) {
    this.gameAudio.click.get();
    if (target === player.countryNo) {
    } else {
      if (this.countries[["top-left","bottom-left", "top-right", "bottom-right"][target]]) {
        this.attackCountry(player,target);
      }
    }
    if (player.countryNo === this.humanPlayer.countryNo) {
      this.setStage("playThroughAge");
      this.stopFiring = false;
      this.startFiring = true;
    }
  }

  fireCannon(targetTimes, numTimes = 0) {
    if (numTimes === targetTimes || this.stopFiring) return;
    this.gameAudio.cannon.get();
    let that = this;
    let randNum = Math.random()*2000 + 500;
    setTimeout(() => {
      that.fireCannon(targetTimes, numTimes + 1);
    },randNum);
    setTimeout(() => {
      that.gameAudio.splash.get();
    },1000);
  }

  startCannon () {
    if (this.startFiring) {
      this.fireCannon(20);
      this.startFiring = false;
    }
  }

  calculateTurns () {
    Object.keys(this.countries).forEach(countryName => {
      this.countries[countryName].player.calculateTurn();
    });
    let that = this;
    window.setTimeout(() => {
      that.nextTurn();
    },8000);
  }

  calculateEngagement (boat) {
    let attacker = this.countries[boat.position];
    let defender = this.countries[boat.destination];
    this.logicBridge.initiateBattle(attacker, defender,this.resizeCountry);
  }

  attackCountry (player, target) {
    if (player.country.view.id !== target) {
      if (this.countries[
        ["top-left","bottom-left", "top-right", "bottom-right"][target]
      ]) {
        this.countries[
          ["top-left","bottom-left", "top-right", "bottom-right"][target]
        ].object.targeted();
        let newBoat = new Boat({
          width: DIM_X, height: DIM_Y, game: this,
          visible: true, position: player.country.object.name,
          destination: ["top-left","bottom-left", "top-right", "bottom-right"][target],
          countries: this.countries,
          purpose: "war",
          startCannon: this.startCannon.bind(this)
        });
        this.allMoveableObjects.push(newBoat);
        player.country.object.sendMilitary();
      }
    }
  }

  selectCountry (pickedCountry) {
    this.humanPlayer.setCountry(this.countries[pickedCountry]);
    this.countries[pickedCountry].player = this.humanPlayer;
    let remainingCountries =
      ["top-left", "top-right", "bottom-left", "bottom-right"]
      .filter(spot => spot !== pickedCountry);
    let that = this;
    ["squares", "triangles", "pentagons"].forEach((compName,i) => {
      let country = this.countries[remainingCountries[i]];
      let compPlayer = new Player("ai", compName, country);
      country.player = compPlayer;
    });
    this.establishBases();
  }

  establishBases () {
    if (this.established) {
      return;
    } else {
      this.gameAudio.click.get();
      this.established = true;
      let that = this;
      Object.keys(this.countries).forEach((countryName,i) => {
        let newBoat = new Boat({
          width: DIM_X, height: DIM_Y, game: that,
          visible: true, position: "offMap",
          destination: countryName,
          countries: that.countries,
          purpose: "establish"
        });
        that.allMoveableObjects.push(newBoat);
      });
    }
  }

  establish(country) {
    if (country.player.computer) country.view.player = "computer";
    country.view.techUp(0);
    this.infoScreen.kingSitDown();
    window.setTimeout(()=> {this.setStage("betweenAges");},1000);
  }

  step () {
    this.moveObjects();
  }

  setStage (stage) {
    switch (stage) {
      case "startGame":
        this.interface.startGame();
        this.infoScreen.startGame();
        this.currentAge += 1;
        break;
      case "instructions":
        this.infoScreen.show();
        this.interface.giveInstructions();
        this.infoScreen.giveInstructions();
        break;
      case "resumeGame":
        this.activeGame = true;
        this.interface.resumeGame();
        this.infoScreen.resumeGame();
        break;
      case "offerDecision":
        this.infoScreen.show();
        this.infoScreen.offerDecision();
        this.activeGame = false;
        break;
      case "betweenAges":
        this.stopFiring = true;
        this.infoScreen.show();
        this.interface.goBetweenAges();
        this.infoScreen.goBetweenAges();
        this.activeGame = false;
        break;
      case "bringUpCouncil":
        this.gameAudio.click.get();
        this.infoScreen.show();
        this.infoScreen.bringUpCouncil();
        this.interface.bringUpCouncil();
        this.activeGame = false;
        break;
      case "playThroughAge":
        this.calculateTurns();
        this.interface.resumeGame();
        this.infoScreen.resumeGame();
        this.activeGame = false;
        break;
      case "fullInstructions":
        this.gameAudio.click.get();
        window.open('index.html');
        break;
      case "testWorker":
        this.logicBridge.advanceGeneration(this.humanPlayer);
        break;
      case "endGame":
        //endGame music
        this.infoScreen.show();
        this.stopFiring = true;
        this.infoScreen.endGame();
        this.interface.endGame();
        break;
      case "loseGame":
        this.infoScreen.show();
        this.stopFiring = true;
        this.infoScreen.loseGame();
        this.interface.loseGame();
        break;
      default:

    }
  }

  applyModifier() {
    if (this.infoScreen.text.betweenAges && this.modIsReady) {
      this.gameAudio.click.get();
      this.setStage("resumeGame");
      this.modifier = this.interface.selected;
      this.humanPlayer.modifier = this.modifier;
    }
  }

  selectPerk (perkNo) {
    // this.gameAudio.click.get();
    this.humanPlayer.setPerk(["str","int","devious","average"][perkNo]);
    this.setStage("startGame");
  }

  setSelectedInterface(command) {
    // this.gameAudio.click.get();
    if (this.infoScreen.text.betweenAges && this.modIsReady) {
      this.interface.setSelected(command);
      this.infoScreen.setPerkExplanation(command);
    }
  }

  techUp (country) {
    if (country.object.ageProgress > 1000) {
      country.object.techUp(3);
      country.view.techUp(3);
    } else if (country.object.ageProgress > 100) {
      country.object.techUp(2);
      country.view.techUp(2);
    } else if (country.object.ageProgress > 10) {
      country.object.techUp(1);
      country.view.techUp(1);
    }
  }

  nextTurn() {
    Object.keys(this.countries).forEach(country => {
      let thisCountry = this.countries[country];
      thisCountry.view.adjustSize(thisCountry);
      thisCountry.player.applyModifiers();
      thisCountry.object.setMorale();
      this.techUp(thisCountry);
    });
    setTimeout(() => {
      this.logicBridge.advanceGeneration(this.humanPlayer);
    }, 1500);

  }

  ageUp() {
    if (this.currentAge < this.targetAge) {
      this.currentAge += 1;
      this.infoScreen.setBetweenAgeMessage();
      this.setStage("betweenAges");
      let that = this;
      window.setTimeout(() => {
        for (let i = that.allMoveableObjects.length - 1; i >= 0 ; i--) {
          that.remove(that.allMoveableObjects[i]);
        }
        for (let i = 0; i < 20; i++) {
          that.allMoveableObjects.push(
            new Wave({position: i, width: DIM_X, height: DIM_Y, game: that})
          );
        }
        Object.keys(this.countries).forEach(country => {
          let thisCountry = this.countries[country];
          thisCountry.view.setColorToClimate();
          thisCountry.object.returnMilitary();
        });
      },1500);
    } else {
      this.endGame();
    }
  }

  wonGame() {
    if (Object.keys(this.countries).length === 1) {
      this.place = "first";
      return true;
    } else {
      let countries = [];
      for (let country in this.countries) {
        if (this.countries.hasOwnProperty(country)) {
          countries.push(this.countries[country]);
        }
      }
      let sorted = countries.sort((a,b) => b.object.size - a.object.size);
      let players = sorted.map(country => country.player);
      let position =
        ["first","second", "third", "fourth"][players.indexOf(this.humanPlayer)];
      this.place = position;
      return position === "first";
    }
  }

  endGame () {
    debugger
    this.notOver = false;
    if (this.wonGame()) {
      this.victory = true;
      this.setStage("endGame");
    } else {
      this.victory = false;
      this.setStage("endGame");
    }
  }

  loseGame () {
    this.setStage("loseGame");
  }

  replayGame () {
    location.reload();
  }

  moveObjects () {
    this.allMoveableObjects.forEach((object) => object.move());
  }

  remove (object) {
    this.allMoveableObjects.splice(this.allMoveableObjects.indexOf(object),1);
  }

  wrap(pos) {
    return [
      Util.wrap(pos[0], (DIM_X - 50) * 0.7), Util.wrap(pos[1], (DIM_Y))
    ];
  }
}

module.exports = Game;



/*****************
 ** WEBPACK FOOTER
 ** ./game/handlers/game.js
 ** module id = 1
 ** module chunks = 0
 **/